import { Empty, Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface SuppliersEmptyProps {
  hasSearch?: boolean
}

export function SuppliersEmpty({ hasSearch }: SuppliersEmptyProps) {
  const { t } = useTranslation()

  const content = hasSearch ? (
    <Flex vertical className="text-center py-3">
      <Text type="secondary" strong>
        {t("suppliers.empty.noMatches")}
      </Text>
      <Text type="secondary" className="mt-1">
        {t("suppliers.empty.tryOtherKeywords")}
      </Text>
    </Flex>
  ) : (
    t("suppliers.empty.none")
  )

  return <Empty description={content} />
}
